import { onMounted, ref } from 'vue';
import { isServer } from '@sitecore-jss/sitecore-jss/utils';
import { pxToRem } from './scalingUtils';

const useMedia = (mediaQuery: string) => {
  const matchMedia = isServer() ? { matches: false } : window.matchMedia(pxToRem(mediaQuery));
  const isMedia = ref(matchMedia.matches);

  const checkMediaMatches = () => {
    isMedia.value = matchMedia.matches;
  };

  if (!isServer()) (matchMedia as MediaQueryList).onchange = checkMediaMatches;

  onMounted(() => {
    checkMediaMatches();
  });

  return { isMedia };
};

export default useMedia;
